// Central configuration for Cole Harbour Masjid.
// Update these values in one place and they apply across the whole site.

export const MASJID = {
  name: 'Cole Harbour Masjid',
  shortName: 'CHMCC',
  domain: 'chicentre.ca',
  contactEmail: 'imanhfx@gmail.com',
  interacEmail: 'imanhfx@gmail.com',
  // TODO: Replace with the masjid's real phone number when available
  phone: '',
  fridayPrayer: {
    locationName: 'Cole Harbour Masjid',
    room: 'Prayer Hall',
    jummah: '1:30 PM',
    address: '1213 Cole Harbour Rd, Dartmouth, NS B2V 1M9',
    mapEmbedUrl:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2837.298683640626!2d-63.48014173022606!3d44.67267844236579!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4b5a24974359ab1b%3A0x12b29681d0f55224!2s1213%20Cole%20Harbour%20Rd%2C%20Dartmouth%2C%20NS%20B2V%201M9!5e0!3m2!1sen!2sca!4v1793560715078!5m2!1sen!2sca',
    appleDirectionsUrl:
      'http://maps.apple.com/?daddr=1213+Cole+Harbour+Rd,+Dartmouth,+NS+B2V+1M9&dirflg=d',
    googleDirectionsUrl:
      'https://www.google.com/maps/dir/?api=1&destination=1213+Cole+Harbour+Rd,+Dartmouth,+NS+B2V+1M9',
  },
  // Interim donation flow: until a payment gateway is in place, the "Donate"
  // call-to-action points to a Google Form where supporters register interest
  // and the team follows up.
  // TODO: Paste the published Google Form URL here (e.g. https://forms.gle/xxxxxxxx).
  // While this is empty the button stays disabled so it never leads to a broken page.
  donationFormUrl: '',

  // Contact form submissions are sent straight to a Google Form (no backend
  // required). To set this up:
  //   1. Create a Google Form with questions for Name, Last Name, Email,
  //      Subject and Message.
  //   2. Click "Send" > link, or open the live form and "Get pre-filled link".
  //      The submit URL is:
  //        https://docs.google.com/forms/d/e/<FORM_ID>/formResponse
  //   3. Find each question's entry ID (from the pre-filled link, or by
  //      inspecting each input's name attribute, e.g. "entry.123456789") and
  //      map them below.
  // Until `actionUrl` is filled in, the form still validates and shows a
  // confirmation message (submissions are simply not transmitted yet).
  contactForm: {
    actionUrl: '', // e.g. 'https://docs.google.com/forms/d/e/FORM_ID/formResponse'
    fields: {
      name: '', // e.g. 'entry.1111111111'
      lastname: '', // e.g. 'entry.2222222222'
      email: '', // e.g. 'entry.3333333333'
      subject: '', // e.g. 'entry.4444444444'
      message: '', // e.g. 'entry.5555555555'
    },
  },
  address: {
    locality: 'Cole Harbour',
    region: 'Nova Scotia',
    country: 'Canada',
    full: 'Cole Harbour, Nova Scotia, Canada',
  },
  // Coordinates for Cole Harbour, NS (used for prayer time calculations)
  location: {
    latitude: 44.6719,
    longitude: -63.473,
    timezone: 'America/Halifax',
  },
};

// Aladhan prayer-times calculation method.
// 2 = Islamic Society of North America (ISNA) — appropriate for Canada/US.
// See https://aladhan.com/calculation-methods for other options.
export const PRAYER_CALCULATION_METHOD = 2;

export default MASJID;
